const POLL_MS = 2000;
const MAX_WAIT_MS = 5 * 60 * 1000;

export async function waitForInitialMarketData(fetchSnapshot, {
    isCurrent,
    wait = (ms) => new Promise((resolve) => window.setTimeout(resolve, ms)),
    now = Date.now,
    timeoutMs = MAX_WAIT_MS,
}) {
    const deadline = now() + timeoutMs;
    while (isCurrent()) {
        let response;
        try {
            response = await fetchSnapshot();
        } catch (error) {
            if (!isCurrent()) return null;
            if (error?.code === 'watchlist_factor_context_changed') throw error;
            const transient = error instanceof TypeError || error?.retryable === true;
            if (!transient || now() >= deadline) throw error;
            await wait(POLL_MS);
            continue;
        }
        if (!isCurrent()) return null;
        const readiness = response?.initial_market_data;
        if (readiness?.status === 'ready') return response;
        if (readiness?.status !== 'pending' || now() >= deadline) {
            const error = new Error(
                readiness?.status === 'failed'
                    ? 'Some Watchlist market data could not be retrieved after retries. The update has not finished loading.'
                    : 'Watchlist market data is still loading. Please retry the refresh; your uploaded securities are saved.',
            );
            error.code = 'watchlist_initial_market_data_incomplete';
            error.retryable = false;
            throw error;
        }
        await wait(POLL_MS);
    }
    return null;
}
